import React from 'react';
import AddressStoreModal from '../AddressStoreModal';
import AddressLockerModal from '../AddressLockerModal';

const AddressStoreSelected = () => {
  if (process.env.REACT_APP_MODE_LOCKER === '1') return <AddressLockerModal />;

  return <AddressStoreModal />;
};

export { AddressStoreSelected };
